import { Box } from "@material-ui/core";
import React from "react";
import useTranslate from "../../../../../hooks/use-translate";
import { PRODUCT_DETAILS_ACTIONS_HEIGHT } from "./styles";

export default function DisabledActionButton({
  children
}: {
  children: string;
}) {
  const t = useTranslate();
  return (
    <Box
      width="100%"
      maxWidth="none"
      height={PRODUCT_DETAILS_ACTIONS_HEIGHT}
      bgcolor="grey.400"
      borderRadius={PRODUCT_DETAILS_ACTIONS_HEIGHT}
      fontWeight={600}
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{
        letterSpacing: "1.5px",
        textTransform: "uppercase",
        userSelect: "none"
      }}
    >
      {children}
    </Box>
  );
}
